import { Navigate } from 'react-router';

const RedirectWrapper = (props) => {
  // eslint-disable-next-line
  const { path = "" } = props;
  return <Navigate to={path} />;
};

export default RedirectWrapper;
